import { useGateValue } from '@statsig/react-bindings'

import {
   APPLICATION_MANAGEMENT_GATE,
   PMU_PORTAL_GATE
} from '../constants/FeatureGatesConstants'

const useGetFeatureGates = () => {
   const isApplicationManagementGateEnabled = useGateValue(
      APPLICATION_MANAGEMENT_GATE
   )
   const isPMUPortalGateEnabled = useGateValue(PMU_PORTAL_GATE)

   return {
      isApplicationManagementGateEnabled,
      isPMUPortalGateEnabled
   }
}

export default useGetFeatureGates
